import { render, staticRenderFns } from "./labelDetailBox.vue?vue&type=template&id=424bf1a5"
import script from "./labelDetailBox.vue?vue&type=script&lang=js"
export * from "./labelDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports